import React, {useState, useContext} from "react";
import { Link } from "react-router-dom";
import {useUser} from 'reactfire';
import ProductsContext from '../Context/AppContext';
import "./css.css";
import getType from '../getTypes';

export default function Product(props) {
  var link = `/products/${props.id}`
  if(useUser()) link = `/admin/products/${props.id}`

  const [loadImg, setLoadImg] = useState(false);
  const handleSetLoadImg = () => {
    setLoadImg(true);
  }

  const {setScrollTop} = useContext(ProductsContext);

  const handleOnClick = () => {setScrollTop(window.pageYOffset)}

  const canEfec = () => {
    if(props.category !== "accesory" && props.category !== "boxer" && props.category !== "fragrance")
      return true;
    return false;
  }

  return (
    <div className="product">
      <Link className="img-sizes" onClick={handleOnClick} to={link}>
        {!loadImg ? 
        <div className="cargando">
          <img 
          src={props.img}
          onLoad={handleSetLoadImg}
          alt="imagen del producto"
          className="img-invisible"
        />
        </div>
        :<div className="content-img-product">
         <img 
            src={props.img}
            onLoad={handleSetLoadImg}
            alt="imagen del producto"
            className="img-product"
          />
        </div>
        }
        
        <div className="info-product">
          <p className="name-product">{props.name ? props.name : getType(props.category)}</p>
            {props.sizes &&
          <div className="sizes">Talles: 
              {props.sizes.map((size, index) => (
                <b key={index}>{index === 0 ? size : ", " + size}</b>
              ))}
          </div>
              }
              <p className="price-product">${props.price}</p>
              {canEfec() &&
                <div className="send">
                  <span role="img" aria-label="dollar banknote">💵</span>
                  <p className="cuots-product"><span className="efec-line">${props.price}</span> <b>${(props.price * 0.90).toFixed(2)}</b></p>
                </div>
                }
              <div className="send">
                <span role="img" aria-label="credit card">💳</span>
                <p className="cuots-product">x3 <b>${(props.price / 3).toFixed(2)}</b></p>
              </div>
        </div>
      </Link>
    </div>
  );
}
